import React from 'react';
import { Loader, Select, Text } from '@mantine/core';
import {
  AUTO_RESOLUTION,
  MEDIA_CONTEXTS,
  resolutionOptions,
} from '../../../shared/media/mediaResolution';
import { useBankMedia } from '../../utils/useBankMedia';

/**
 * Surcharge du palier de résolution d'un média déjà posé.
 *
 * Le défaut du site est `auto` : `srcset` sur la balise, le navigateur choisit
 * selon l'écran et la densité. Ce champ existe pour les cas où l'utilisateur
 * sait mieux — une image de fond qu'il veut légère, une photo qu'il veut nette
 * quoi qu'il arrive. Le choix est écrit dans le bloc, pas recalculé au rendu.
 *
 * Rien à afficher tant que le média ne vient pas de la banque : une URL collée
 * à la main n'a pas de paliers.
 */
export default function MediaResolutionField({
  mediaId,
  resolution = AUTO_RESOLUTION,
  onChange,
  context = MEDIA_CONTEXTS.web,
}) {
  const { media, loading } = useBankMedia(mediaId);

  if (!mediaId) return null;
  if (!media) return loading ? <Loader size="xs" mt={6} /> : null;

  const options = resolutionOptions(media, context);
  if (options.length < 2) return null;

  return (
    <>
      <Select
        mt={6}
        size="xs"
        label="Résolution"
        data={options}
        value={options.some((o) => o.value === resolution) ? resolution : options[0].value}
        onChange={(next) => next && onChange(next, media)}
        allowDeselect={false}
        comboboxProps={{ withinPortal: true }}
      />
      {resolution === AUTO_RESOLUTION && (
        <Text size="xs" c="dimmed" mt={2}>
          Le navigateur choisit le palier selon l&apos;écran du visiteur.
        </Text>
      )}
    </>
  );
}
